import { useEffect } from 'react';
import { SESSION_END_REASON, onSessionEnded } from '../domain/Auth';
import history from '../history';

/** The ways a session ends that hand the browser to whoever signs in next. */
const HANDED_OVER = [SESSION_END_REASON.LOGGED_OUT, SESSION_END_REASON.OTHER_TAB];

/**
 * Sends the browser home when an admin chose to end the session, here or in
 * another tab, so whoever signs in next starts at `/` and not on the page the
 * previous admin left open. A session that expired or was stored by another
 * build keeps its URL: the same admin signs back in and resumes there, and a
 * link opened while signed out survives sign-in.
 */
export const useLogoutRedirect = () => {
  useEffect(
    () =>
      onSessionEnded((reason) => {
        if (HANDED_OVER.includes(reason)) history.replace('/');
      }),
    [],
  );
};

export default useLogoutRedirect;
